export const INPUT_ACCEPTANCE_CRITERIA = '.pdf,application/pdf';

export const OBJECTIVES_FORM_MAX_FILE_SIZE = 5242880; // 5MB
